import React from "react";
import Select from "react-select";

interface OptionType {
  value: string;
  label: string;
  imageUrl?: string;
}

interface ImageSelectProps {
  options: OptionType[];
  onChange: (value: OptionType[] | null) => void;
  value?: OptionType[];
  isMulti?: boolean;
  placeholder?: string;
}

const ImageSelect: React.FC<ImageSelectProps> = ({
  options,
  onChange,
  value,
  isMulti = true,
  placeholder = "Select",
}) => {
  const getInitials = (name: string) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }
    return (
      (parts[0][0] || "").toUpperCase() +
      (parts[parts.length - 1][0] || "").toUpperCase()
    );
  };

  const CustomOption = ({ data, innerRef, innerProps, isSelected }: any) => (
    <div
      ref={innerRef}
      {...innerProps}
      className="d-flex align-items-center justify-content-between px-3 py-2 option-item"
      style={{
        backgroundColor: isSelected ? "#e6f7ff" : "white",
        borderBottom: "1px solid #f1f1f1",
        cursor: "pointer",
      }}
    >
      <div className="d-flex align-items-center">
        {data.imageUrl ? (
          <img
            src={data.imageUrl}
            alt={data.label}
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: 10,
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          />
        ) : (
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: "#6c757d",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "13px",
              fontWeight: 600,
              marginRight: 10,
              textTransform: "uppercase",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {getInitials(data.label)}
          </div>
        )}
        <span style={{ fontSize: "14px", fontWeight: 500 }}>{data.label}</span>
      </div>
      {isSelected && (
        <span className="text-success" style={{ fontSize: "16px" }}>
          ✔
        </span>
      )}
    </div>
  );

  return (
    <Select
      options={options}
      isMulti={isMulti}
      value={value}
      onChange={onChange}
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
      controlShouldRenderValue={false}
      isClearable={false}
      placeholder={placeholder}
      components={{ Option: CustomOption }}
      styles={{
        menu: (base: any) => ({
          ...base,
          borderRadius: 8,
          overflow: "hidden",
          zIndex: 99,
        }),
        control: (base: any) => ({
          ...base,
          minHeight: "40px",
          borderRadius: 8,
          borderColor: "#ccc",
          boxShadow: "none",
          "&:hover": { borderColor: "#999" },
        }),
        menuList: (base: any) => ({
          ...base,
          padding: 0,
        }),
        placeholder: (base: any) => ({
          ...base,
          fontSize: "14px",
          color: "#888",
        }),
      }}
    />
  );
};

export default ImageSelect;
